// src/utils/aes.ts
import crypto from "crypto-js";

const ENCRYPTION_KEY = import.meta.env.VITE_ENCRYPTION_KEY;
const KEY = crypto.enc.Utf8.parse(ENCRYPTION_KEY);
const IV_LENGTH = 16;

export function encryptAES<T = Record<string, unknown>>(data: T): string {
  const iv = crypto.lib.WordArray.random(IV_LENGTH);
  const encrypted = crypto.AES.encrypt(JSON.stringify(data), KEY, {
    iv,
    mode: crypto.mode.CBC,
    padding: crypto.pad.Pkcs7,
  });

  return crypto.enc.Base64.stringify(iv) + ":" + encrypted.toString();
}

export function decryptAES<T = unknown>(encrypted: string): T {
  const [ivBase64, encryptedData] = encrypted.split(":");
  const iv = crypto.enc.Base64.parse(ivBase64);

  const decrypted = crypto.AES.decrypt(encryptedData, KEY, {
    iv,
    mode: crypto.mode.CBC,
    padding: crypto.pad.Pkcs7,
  });

  const json = decrypted.toString(crypto.enc.Utf8);
  return JSON.parse(json) as T;
}
